import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import * as Rx from 'rxjs';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});
@Injectable({
  providedIn: 'root'
})
export class JaldeeReportService {
  reportUrl = '/superadmin/rest/mgmt/jc/reports';
  reportreimburseUrl = '/superadmin/rest/mgmt/jc/reportfilter';
  reimburseurl = '/superadmin/rest/mgmt/jc/reimburse';
  regenerateUrl = '/superadmin/rest/mgmt/jc/reimburse/report/reGenerate';
  cancelReportUrl = '/superadmin/rest/mgmt/jc/reimburse/report/cancel';
  s3Url = '/superadmin/rest/mgmt/login/s3Url';
  noteUrl = '/superadmin/rest/mgmt/jc/reimburse';
  // reportCountUrl = '/superadmin/rest/mgmt/jc/reportfilter';
  // reportFilterUrl = '/superadmin/rest/mgmt/jc/reportfilter';
  constructor(private http: HttpClient) { }
  getReports(
    filter, sortOrder,
    pageNumber, pageSize = 10 , reimburseid):  Observable<any> {
      console.log(reimburseid);
    return this.http.get(this.reportUrl  + '?' + 'reportId-eq=' + reimburseid.id  + '&&' + filter, {
        params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
    });
}
getReportss(
  filter, sortOrder,
  pageNumber, pageSize = 10 ):  Observable<any> {
  return this.http.get(this.reportUrl  + '?' + '&&' + filter, {
      params: new HttpParams()
          .set('asc', sortOrder)
          .set('from', pageNumber.toString())
          .set('count', pageSize.toString())
  });
}
getReimburseReports(
  filter , sortOrder,
  pageNumber, pageSize = 10):  Observable<any> {

  return this.http.get(this.reportreimburseUrl + '?' + filter, {
      params: new HttpParams()
          .set('asc', sortOrder)
          .set('from', pageNumber.toString())
          .set('count', pageSize.toString())
  });
}
getInvoiceDetails(s3UrlPath): Observable<any> {
  return this.http.get( s3UrlPath);
}
reimburse(data) {
  return this.http.post(this.reimburseurl , data, {headers: headers} );
}
getReimbursePaymentDetails(invoiceId) {
  return this.http.get(this.reimburseurl + '/' + invoiceId , {headers: headers});
}
getReimburseReportDetails(invoiceId) {
  return this.http.get(this.reimburseurl + '/' + invoiceId , {headers: headers});
}
getTotalFilterCount(filter: any , reimburseid): any {
  return this.http.get(this.reportUrl  + '/count?reportId-eq=' + reimburseid.id  + '&&' + filter, {headers});
 }
 getTotalReimburseFilterCount(filter: any): any {
  return this.http.get(this.reportUrl  + '/count?' + filter, {headers});
 }
getTotalReportFilterCount(filter: any): any {
  return this.http.get(this.reportreimburseUrl + '/count?' + filter, {headers});
 }
 changeInvoiceStatus(invoiceId, status) {
   return this.http.put(this.reimburseurl + '/' + invoiceId + '/' + status, {headers: headers});
 }
 getS3Url() {
   return this.http.get(this.s3Url, {headers: headers});
 }
 regenerateReport(Id) {
  return this.http.put(this.regenerateUrl + '/' + Id , {headers: headers});
 }
 cancelReport(Id) {
  return this.http.delete(this.cancelReportUrl + '/' + Id , {headers: headers});
 }
 addNotes(Id,data) {
  return this.http.put(this.noteUrl + '/' + Id ,data ,{headers: headers});
 }
 noteUpdate(invoiceid,paymentid,data){
  return this.http.put(this.noteUrl + '/' + invoiceid + '/notes/' + paymentid ,data ,{headers: headers});
 }
}
